import React from 'react'
import { Modal, Button } from 'react-bootstrap'

const RoleModal = ({ show, setShow }) => {
  const handleClose = () => setShow(false)

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Role Score</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        Role score is a measure of the weighted sum of permissions and
        conflicts, multiplied by the number of users with that role, normalize
        on a scale of 1 - 100.
        <br />
        <br />
        <strong>Weighting</strong>
        <ul>
          <li>High Risk Permission: 0.25 pts</li>
          <li>External Conflict (between two roles): 1 pts</li>
          <li>Internal Conflict: 2 pts</li>
          <li>Superuser Permission: 3 pts</li>
        </ul>
        <br />
        <strong>Example Score</strong>
        <p>A role with 5 employees the following permissions and conflicts:</p>
        <ul>
          <li>20 High Risk Permissions</li>
          <li>1 External Conflict</li>
          <li>4 Internal Conflicts</li>
          <li>1 Superuser Permission</li>
        </ul>
        The score would be calculated as follows:
        <ul>
          <li>20 * 0.25 = 5 (High Risk)</li>
          <li>1 * 1 = 1 (External Conflicts)</li>
          <li>4 * 2 = 8 (Internal Conflicts)</li>
          <li>1 * 3 = 3 (Superuser Permissions)</li>
          <li>Permission/Conflict Sum: 17</li>
          <li>Number of Employees: 5</li>
          <li>Raw Score: (17 / 5) * 100 = 340</li>
        </ul>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="light-primary" onClick={handleClose}>
          Close
        </Button>
        <Button variant="primary" onClick={handleClose}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default RoleModal
